import { render } from "./InvitationDialog.vue?vue&type=template&id=474294cd"
import script from "./InvitationDialog.vue?vue&type=script&lang=js"
export * from "./InvitationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__